import * as React from 'react';
import injectSheet from 'react-jss';
import { StylesProps } from '../../types/common.types';
import LockIcon from './icons/LockIcon';
import { CssType, ThemeType } from '../../theming/jssTypes';

const styles = (theme: ThemeType): CssType => ({
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    background: '#fff',
    marginTop: '15%',
  },
  flexBoxFullScreen: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '100vh',
    background: theme.color.semantic.background.neutral.secondary,
  },
  lockIcon: {
    fontSize: 104,
  },
  title: {
    paddingTop: 20,
    color: '#262626',
    fontSize: 28,
    fontWeight: 600,
  },
  subTitle: {
    fontSize: 16,
    color: '#262626',
    paddingTop: 8,
  },
});

type UnauthorizedAccessProps = StylesProps<ReturnType<typeof styles>> & {
  title?: string;
  subTitle?: string;
  fullScreen?: boolean;
};

const UnauthorizedAccess = ({
  classes,
  title = 'OOPS!',
  subTitle = "You don't have the necessary access to the page",
  fullScreen = false,
}: UnauthorizedAccessProps) => (
  <div className={fullScreen ? classes.flexBoxFullScreen : classes.flexBox}>
    <LockIcon className={classes.lockIcon}></LockIcon>
    <div className={classes.title}>{title}</div>
    <div className={classes.subTitle}>{subTitle}</div>
  </div>
);

export default injectSheet(styles)(UnauthorizedAccess);
